import { StipendWalletResponse } from "@common/utils/graphql";
import { ProgressBar } from "./ProgressBar";
import { formatLongDate } from "@common/components/utils";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "@phosphor-icons/react";
import { Body } from "@hypercard/web-components";

export const BudgetProgressBar = (props: {
  stipend: StipendWalletResponse;
  isExpired: boolean;
  isDisabled: boolean;
}) => {
  const { stipend, isExpired, isDisabled } = props;
  const isInactive = isExpired || isDisabled;

  const preventHidingToast = (
    e:
      | CustomEvent<{ originalEvent: PointerEvent }>
      | React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.preventDefault();
  };
  return (
    <div className="flex gap-10">
      <ProgressBar stipend={stipend} isInactive={isInactive} />
      <div className="space-y-2">
        <Body size="sm" weight="regular" className="text-white/50">
          Expiry Date
        </Body>
        <Body size="md" weight="regular">
          {stipend?.expiresAt
            ? formatLongDate(stipend?.expiresAt)
            : "No expiry"}
        </Body>
      </div>
      {isInactive && (
        <div className="space-y-2">
          <div className="flex items-start gap-2">
            <Body size="sm" weight="regular" className="text-white/50">
              Status
            </Body>
            {!isExpired && (
              <Tooltip delayDuration={100}>
                <TooltipTrigger onClick={preventHidingToast}>
                  <Info className="size-4 text-white/50" />
                </TooltipTrigger>
                <TooltipContent
                  onPointerDownOutside={preventHidingToast}
                  className="max-w-[300px]"
                >
                  <Body size="sm" weight="medium">
                    This stipend has been manually disabled. For more
                    information contact your organization's administrators.
                  </Body>
                  <TooltipArrow />
                </TooltipContent>
              </Tooltip>
            )}
          </div>
          <Body size="md" weight="regular">
            {isExpired ? "Expired" : "Disabled"}
          </Body>
        </div>
      )}
    </div>
  );
};
